<template>
  <v-app>
    <div class="change-password-wrapper">
      <div class="change-password-bg">
        <v-card
          width="700px"
          height="280px"
        >
          <v-card-title>
            Change password
          </v-card-title>

          <v-card-text>
            <ums-password-field
              v-model="password"
              label="New Password"
              @keypress.enter="changePassword"
            />

            <ums-password-field
              v-model="confirmedPassword"
              :custom-validator="confirmedPasswordValidator"
              label="Confirm New Password"
              @keypress.enter="changePassword"
            />
          </v-card-text>

          <v-layout
            justify-space-between
            style="padding-right: 14px; padding-left: 14px;"
          >
            <span :class="errorMsg ? 'error--text' : 'success--text'">
              {{ errorMsg || successMsg }}
            </span>

            <v-btn
              :disabled="disableChange"
              color="success"
              small
              @click="changePassword"
            >
              Change password
            </v-btn>
          </v-layout>
        </v-card>
      </div>
    </div>

    <vbt-loading
      v-if="loading"
      fullscreen
    />
  </v-app>
</template>

<script>
import { wrapToLoadingFn } from '@helpers';

import UmsPasswordField from '@components/UmsPasswordField.vue';

import { ChangePasswordApiService } from '../_services/changePassword.api.service';

export default {
  name: 'ChangePassword',

  components: {
    UmsPasswordField,
  },

  data() {
    return {
      password: '',
      confirmedPassword: '',

      loading: false,
      successMsg: '',
      errorMsg: '',
    };
  },

  watch: {
    password() {
      this.clearErrors();
    },
    confirmedPassword() {
      this.clearErrors();
    },
  },

  computed: {
    disableChange() {
      return !this.password
        || !this.confirmedPassword
        || (this.password !== this.confirmedPassword);
    },
  },

  methods: {
    changePassword() {
      if (this.disableChange) {
        return;
      }

      this.clearErrors();

      this.wrapToLoadingFn({
        req: ChangePasswordApiService.changePassword.bind({}, {
          token: this.$route.query.token,
          password: this.password,
        }),
        loadingFlagName: 'loading',
        onSuccess: () => {
          this.successMsg = 'Password successfully changed';

          this.confirmedPassword = '';
          this.password = '';
        },
        onReject: (e) => {
          this.errorMsg = e.msg;
        },
      });
    },

    clearErrors() {
      this.successMsg = '';
      this.errorMsg = '';
    },

    confirmedPasswordValidator(v) {
      return this.password === v || 'Wrong password';
    },

    wrapToLoadingFn,
  },
};
</script>

<style>
.change-password-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 100vh;
  font-family: sans-serif;
}

.change-password-wrapper .change-password-bg {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #121212;
  background-image: url(../../../components/AppLogin/bg.jpg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
